var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 1.73913,
    fill: "#D0DBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5694 8.6524V9.30095C11.5694 9.48003 11.4242 9.62523 11.2451 9.62523H9.62373C8.19101 9.62523 7.02952 10.7867 7.02952 12.2194C7.02952 13.6522 8.19101 14.8136 9.62373 14.8136H11.2451C11.4242 14.8136 11.5694 14.9588 11.5694 15.1379V15.7865C11.5694 15.9655 11.4242 16.1107 11.2451 16.1107H9.62373C7.47461 16.1107 5.73242 14.3685 5.73242 12.2194C5.73242 10.0703 7.47461 8.32812 9.62373 8.32812H11.2451C11.4242 8.32812 11.5694 8.47332 11.5694 8.6524ZM14.8121 8.32812C16.9612 8.32812 18.7034 10.0703 18.7034 12.2194C18.7034 14.3685 16.9612 16.1107 14.8121 16.1107H13.1908C13.0117 16.1107 12.8665 15.9655 12.8665 15.7865V15.1379C12.8665 14.9588 13.0117 14.8136 13.1908 14.8136H14.8121C16.2448 14.8136 17.4063 13.6522 17.4063 12.2194C17.4063 10.7867 16.2448 9.62523 14.8121 9.62523H13.1908C13.0117 9.62523 12.8665 9.48003 12.8665 9.30095V8.6524C12.8665 8.47332 13.0117 8.32812 13.1908 8.32812H14.8121ZM9.948 11.5709C9.76892 11.5709 9.62373 11.7161 9.62373 11.8952V12.5437C9.62373 12.7228 9.76892 12.868 9.948 12.868H14.4879C14.6669 12.868 14.8121 12.7228 14.8121 12.5437V11.8952C14.8121 11.7161 14.6669 11.5709 14.4879 11.5709H9.948Z",
    fill: "#9DB2F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIconSmall);
export default __webpack_public_path__ + "static/media/link-icon-small.222992ec.svg";
export { ForwardRef as ReactComponent };